<template>
  <div class="stats-list-outer">
    <router-view></router-view>
    <div class="list-header">VoD Export Statistics</div>
    <div class="loading" v-if="loading">
      <p>Generating Statistics...</p>
    </div>
    <br />
    <p class="stats-entry">
      <b>Ready for delivery:</b> {{ readyForReview ? "✅ " : "⛔ " }}
    </p>
    <p class="stats-entry">
      <b>Previous exports cleared:</b> {{ previousExportsCleared ? "✅ " : "⛔ " }}
    </p>
    <Button :disabled="!readyForReview || !previousExportsCleared || allowTransferProd" class="publish-button" size="small" @click="deliverCollectionClick()">publish</Button>
    <p class="stats-entry">
      <Tooltip>
        <template slot="title">
          NOT ingestion_running
        </template>
        <b>Allow for delivery:</b>
        {{ allowTransferProd ? "✅(prod) " : "⛔(prod) " }}
        {{ allowTransferTest ? "✅(test) " : "⛔(test) " }}
      </Tooltip>
    </p>

    <p class="stats-entry">
      <Tooltip>
        <template slot="title">
          transfer_finished_prod
        </template>
        <b>Was deliverd:</b>
        {{ transferFinishedProd ?  "✅(prod) " : "⛔(prod) " }}
        {{ transferFinishedTest ?  "✅(test) " : "⛔(test) " }}
      </Tooltip>
    </p>

    <Table :columns='columns' size="small" :pagination="false" class="stats-table" :data-source='statsData' />
    <div class="stats-list">
      <p class="list-head">Häufigste Titel (Serien)</p>
      <b-row
        class="list-row"
        v-for="item in titleDistribution"
        :key="item.title"
        @click="itemClicked(item)">
        <b-col cols="1" class="mui--text-left">
          <p>{{ item.num_title }}</p>
        </b-col>
        <b-col cols="2" class="mui--text-left">
          <p>{{ item.num_title / stats.resultCount | percentage(2) }}</p>
        </b-col>
        <b-col cols="8" class="mui--text-left">
          <p>{{ item.title }}</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Button, Tooltip, List, Table } from 'ant-design-vue'

const columns = [
  {
    title: 'Check',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: 'Value',
    dataIndex: 'value',
    key: 'value',
    align: 'right'
  }
]

export default {
  name: 'Stats',
  props: [
    'collectionName'
  ],
  components: {
    Button,
    Tooltip,
    List,
    Table
  },
  data () {
    return {
      columns,
      title: 'Name',
      editing: false,

      stats: {
        resultCount: 1,
        moviesCount: 0,
        seriesCount: 0,
        titleCoverage: 0,
        originalTitleCoverage: 0,
        webUrlCoverage: 0,
        seasonUrlCoverage: 0,
        episodeUrlCoverage: 0
      },
      titleDistribution: [
        {
          title: 'test',
          num_title: 1
        }
      ],
      selectedVodProvider: '',
      burdaCollectionName: undefined,
      allowTransferProd: undefined,
      allowTransferTest: undefined,
      readyForReview: undefined,
      transferFinishedProd: false,
      transferFinishedTest: false,
      previousExportsCleared: true,
      loading: true
    }
  },
  watch: {
    collectionName: function (val) {
      // when the hash prop changes, this function will be fired.
      this.activeCollectionName = val
      this.getStats()
      this.getBurdaStats()
      this.getTitleDistribution()
    }
  },
  computed: {
    statsData () {
      let statsDataList = []
      console.log('BERFORE')
      let key = 0
      for (const [name, value] of Object.entries(this.stats)) {
        console.log('BERFORE1')
        let stringValue = ''
        if (value < 1.0) {
          stringValue = (value * 100).toFixed(1) + '%'
        } else {
          stringValue = value
        }
        statsDataList.push({
          key,
          name,
          value: stringValue
        })
        key += 1
      }
      console.log('BERFORE2')
      return statsDataList
    }
  },
  methods: {
    deliverCollection () {
      return new Promise(async (resolve, reject) => {
        console.log('Calling service to deliver collection:', this.burdaCollectionName)
        const deliverBurdaDataUrl = `${this.$hostname}/deliverBurdaData/${this.burdaCollectionName}`
        axios.get(deliverBurdaDataUrl).then(response => {
          console.log('response for delivery was:', response)
          return resolve(response)
        })
      })
    },
    async deliverCollectionClick () {
      if (!this.burdaCollectionName) {
        return
      }
      console.log('Delivering collection:', this.burdaCollectionName)
      const deliveryResult = await this.deliverCollection()
      console.log('Delivered collection. Result:', deliveryResult)
      this.getBurdaStats()
    },
    getBurdaStats () {
      let burdaCollectionName = this.collectionName.split('exported_data')[1].split('T')[0]
      let getProviderUrl = `${this.$hostname}/getExportProvider/${this.collectionName}`

      axios.get(getProviderUrl).then(response => {
        this.selectedVodProvider = response.data.msg.provider
        this.burdaCollectionName = `burda_export_${this.selectedVodProvider}${burdaCollectionName}`

        console.log('burdaCollectionName0', this.burdaCollectionName)
        if (this.burdaCollectionName.startsWith('burda_export_google_video')) {
          console.log('burdaCollectionName1', this.burdaCollectionName)
          this.burdaCollectionName = 'burda_export_google_play' + this.burdaCollectionName.split('burda_export_google_video')[1]
          console.log('burdaCollectionName2', this.burdaCollectionName)
        }

        const getBurdaStatsUrl = `${this.$hostname}/getBurdaStats/${this.burdaCollectionName}`
        console.log('getBurdaStatsUrl', getBurdaStatsUrl)

        axios.get(getBurdaStatsUrl).then(response => {
          console.log('response', response)
          this.ingestionRunning = response.data.ingestion_running
          this.readyForReview = response.data.ready_for_review
          this.previousExportsCleared = response.data.previous_exports_cleared
          this.allowTransferProd = response.data.allow_transfer_prod
          this.allowTransferTest = response.data.allow_transfer_test
          this.transferFinishedProd = response.data.transfer_finished_prod || false
          this.transferFinishedTest = response.data.transfer_finished_test || false
          console.log('this.ingestionRunning', this.ingestionRunning)
        });
      })
    },
    getStats () {
      console.log('Getting Stats from ' + this.collectionName)
      if (this.collectionName && this.collectionName !== '') {
        axios.get(`${this.$hostname}/stats/${this.collectionName}/`)
          .then(response => {
            this.stats = response.data.msg
          })
      }
    },
    itemClicked (item) {
      let idPart = item.firstId
      idPart = idPart.slice(idPart.length - 11, idPart.length) // remove series, episode number part from ID
      console.log('CLICKED: ' + idPart)
      this.$emit('on-selected-id', idPart)
    },
    getTitleDistribution () {
      this.loading = true
      console.log('Getting title distribution from ' + this.collectionName)
      if (this.collectionName && this.collectionName !== '') {
        axios.get(`${this.$hostname}/stats/${this.collectionName}/titleDistribution/`)
          .then(response => {
            console.log('got distribution: ' + response.data.msg.titleDistribution.length)
            this.titleDistribution = response.data.msg.titleDistribution
            this.loading = false
          })
      }
    }
  }}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.stats-list-outer {
  background-color: rgba(255,255,255,0.2);
  color: #000;
  overflow-y: scroll;
  padding: 0px;
  width: 300px;
  min-width: 300px;
  margin: 5px;
  margin-left: 0px;
}
.loading {
  text-align: center;
  position: relative;
  height: 100%;
  width: 100%;
}
.loading p {
  position: absolute;
  top: 50%;
  left: 50%;
  height: 30%;
  width: 50%;
  margin: -15% 0 0 -25%;
}
.list-head {
  background-color: rgba(0,0,0,0.3);
  padding-top: 2px;
  padding-bottom: 2px;
}
.list-row {
  background-color: rgba(255,255,255,0.4);
  box-shadow: inset 0 0 1px #000000;
  cursor: default;
}
.list-row:hover {
  background-color: rgba(255,255,255,0.2);
  box-shadow: 0 0 1px #000000;
}
.stats-list {
  overflow-y: scroll;
  overflow-x: hidden;
  background-color: rgba(255,255,255,0.3);
  line-height: 12px;
  height: 180px;
  margin: 5px;
  box-shadow: 0 0 2px #000000;
  border-radius: 3px;
}
.stats-list p {
  margin: 2px;
}
.list-header {
  background-color: rgba(255,255,255,0.2);
  font-size: 12px;
  text-align: center;
  line-height: 18px;
  padding: 0px;
}
.stats {
  padding: 0px;
  font-size: 12px;
  text-align: left;
}

.stats-table {
  background-color: white;
}

.stats-entry {
  line-height: 2px;
  padding: 5px;
  padding-top: 5px;
  padding-bottom: 0px;
}

.publish-button {
    font-size: small;
    margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Stats.vue